import { z } from "zod";

export const titleCategories = ["descriptive", "poetic", "evocative", "playful"] as const;
const titles = z.array(z.string().trim().min(1).max(120)).max(5);
export const titleGroupsSchema = z.object({
  descriptive: titles,
  poetic: titles,
  evocative: titles,
  playful: titles
});
export type TitleGroups = z.infer<typeof titleGroupsSchema>;
export const titleGenerationSchema = z.object({
  descriptive: titles.length(5),
  poetic: titles.length(5),
  evocative: titles.length(5),
  playful: titles.length(5)
});
export const titleBatchesSchema = z.object({
  batches: z.array(
    z.object({
      id: z.string().uuid(),
      state: z.string(),
      createdAt: z.string(),
      groups: titleGroupsSchema.nullable(),
      error: z.string().nullable()
    })
  )
});
export type TitleBatches = z.infer<typeof titleBatchesSchema>;
export const titleBatchRequestSchema = z.object({ regenerate: z.boolean().default(false) });

export function normalizeTitle(title: string): string {
  return title.trim().replace(/\s+/gu, " ").toLowerCase();
}

export function filterTitleGroups(groups: TitleGroups, existing: string[]): TitleGroups {
  const seen = new Set(existing.map(normalizeTitle));
  const result: TitleGroups = { descriptive: [], poetic: [], evocative: [], playful: [] };
  for (const category of titleCategories) {
    for (const title of groups[category]) {
      const key = normalizeTitle(title);
      if (!key || seen.has(key)) continue;
      seen.add(key);
      result[category].push(title.trim().replace(/\s+/gu, " "));
    }
  }
  return result;
}
